import React, { Component } from 'react';
import { connect } from 'react-redux'

import {
  unselectPointOfSale
} from '../../actions/pointOfSale';

import OverlayContainer from 'ui-kit/src/components/OverlayContainer/OverlayContainer';
import StatefulShopBlock from '../StatefulShopBlock/StatefulShopBlock';

class StatefulMobileShopBlock extends Component {
  render() {
    let index = 1;
    const searchResultsDior = this.props.searchResults.filter(item => item.typeParent === 'Dior');
    const searchResultsOther = this.props.searchResults.filter(item => item.typeParent !== 'Dior');
    if (searchResultsDior.indexOf(this.props.shop) !== -1) {
      index = searchResultsDior.indexOf(this.props.shop) + 1;
    } else {
      index = searchResultsDior.length + searchResultsOther.indexOf(this.props.shop) + 1;
    }

    return (<OverlayContainer
      closeCallback={this.props.closeCallback}
      isOpen={this.props.isMobileShopOpen}
    >
      {this.props.shop && (
        <StatefulShopBlock shop={this.props.shop} label={index} displayItinerary={false} />
      )}
      {this.props.confirmation}
    </OverlayContainer>)
  }
}

const mapStateToProps = (state) => {
  return {
    isMobileShopOpen: state.pointOfSale.isMobileShopOpen,
    searchResults: state.pointOfSale.searchResults,
    shop: state.pointOfSale.selectedItem
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    closeCallback: unselectPointOfSale.bind(null, dispatch, false)
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(StatefulMobileShopBlock);


// WEBPACK FOOTER //
// ./src/components/StatefulMobileShopBlock/StatefulMobileShopBlock.jsx